@if (factsSections() && factsSections().length > 0) {
  <h2 class="text-2xl font-bold mb-2">Snabba fakta om <span>{{ title() }}</span></h2>

  @if (factsFirstSection() && factsFirstSection().length > 0) {
    <div class="flex flex-col gap-4">
      @for (fact of factsFirstSection(); track fact.label.label) {
        <div class="flex flex-col gap-2">
          <div
            [innerHTML]="fact.label.label"
            class="text-base text-grey-3"
          ></div>
          <div
            [innerHTML]="fact.content"
            class="text-base text-grey-1"
          ></div>
        </div>
      }
    </div>
  }

  @if (factsSecondSection() && factsSecondSection().length > 0) {
    <div class="flex flex-col gap-4">
      @for (fact of factsSecondSection(); track fact.label.label) {
        <div class="flex flex-col gap-2">
          <div
            [innerHTML]="fact.label.label"
            class="text-base text-grey-3"
          ></div>
          <div
            [innerHTML]="fact.content"
            class="text-base text-grey-1"
          ></div>
        </div>
      }
    </div>
  }

}

